import { IconProps } from '.';

const SunIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      className={customClasses}
      {...rest}
    >
      <g clipPath="url(#clip0_18177_142897)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.381 7.10078V0.666748H19.794V7.10078H17.381ZM6.18202 4.66828L10.732 9.21783L9.02573 10.9239L4.47579 6.37436L6.18202 4.66828ZM28.5258 27.0088L33.0757 31.5583L31.3695 33.2644L26.8195 28.7149L28.5258 27.0088ZM28.5314 10.9243L33.0814 6.37471L31.3752 4.66863L26.8252 9.21818L28.5314 10.9243ZM10.7376 28.7152L6.18769 33.2648L4.48146 31.5587L9.0314 27.0091L10.7376 28.7152ZM17.381 30.9044V37.3384H19.794V30.9044H17.381ZM7.09865 17.3946H0.664062V19.8074H7.09865V17.3946ZM30.8984 17.3946H37.333V19.8074H30.8984V17.3946ZM26.239 19.0869C26.239 23.0846 22.9982 26.3255 19.0004 26.3255C15.0027 26.3255 11.7618 23.0846 11.7618 19.0869C11.7618 15.0891 15.0027 11.8483 19.0004 11.8483C22.9982 11.8483 26.239 15.0891 26.239 19.0869ZM28.6519 19.0869C28.6519 24.4172 24.3308 28.7383 19.0004 28.7383C13.6701 28.7383 9.34896 24.4172 9.34896 19.0869C9.34896 13.7565 13.6701 9.43539 19.0004 9.43539C24.3308 9.43539 28.6519 13.7565 28.6519 19.0869Z"
          fill={color || 'var(--color-ui-icon-primary)'}
        />
      </g>
      <defs>
        <clipPath id="clip0_18177_142897">
          <rect
            width="40"
            height="40"
            fill={color || 'var(--color-ui-icon-primary)'}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SunIcon;
